export default __webpack_public_path__ + "static/media/cartoon.969b7d5f.png";